import { ActionTypes } from "../store/actionTypes";

abstract class ActionCreator<S> {
    private ServiceCls: { new (): S };
    protected LOADING_TYPE: string;
    protected ERROR_TYPE: string;

    constructor(S: { new (): S }, loadingType: string, errorType: string) {
        this.ServiceCls = S;
        this.LOADING_TYPE = loadingType;
        this.ERROR_TYPE = errorType;
    }
    
    public loading = () => ({
        type: this.LOADING_TYPE,
    });

    public error = (error: any) => ({
        type: this.ERROR_TYPE,
        payload: { error },
    });

    public globalError = (error: any) => ({
        type: ActionTypes.GLOBAL_ERROR,
        payload: { error },
    });
}

export default ActionCreator;
